import { Group, Modal } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../../components/Atoms';

interface DestroyModalProps {
    opened: boolean;
    name: string;
    onClose: () => void;
    onConfirm: () => void;
}

export default function DestroyModal({ opened, name, onClose, onConfirm }: DestroyModalProps) {
    const { t } = useTranslation('cloudCompute');
    return (
        <Modal
            size="sm"
            opened={opened}
            onClose={onClose}
            withCloseButton={false}
            overlayProps={{
                backgroundOpacity: 0.55,
                blur: 3,
            }}
            transitionProps={{ transition: 'fade', duration: 128, timingFunction: 'linear' }}
            centered
        >
            <div className="flex flex-col justify-center items-center gap-4">
                <Modal.Title>
                    <span className="text-base font-bold">{t('destroyModal.title')}</span>
                </Modal.Title>
                <p className="text-sm text-center text-fg/68">
                    {t('destroyModal.message', { name })}
                </p>
                <Group w="100%" wrap="nowrap" gap="xs">
                    <Button
                        width="100%"
                        variant="secondary"
                        color="gray"
                        onClick={onClose}
                        className="font-bold"
                    >
                        {t('destroyModal.cancel')}
                    </Button>
                    <Button width="100%" variant="danger" className="font-bold" onClick={onConfirm}>
                        {t('destroyModal.destroy')}
                    </Button>
                </Group>
                <span className="text-sm text-fg/68">{t('destroyModal.permanent')}</span>
            </div>
        </Modal>
    );
}
